import { useLayoutEffect, useRef } from 'react';

interface EditClassroomDescriptionProps {
    classroomDescription: string,
    handleInputChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void,
    handleClassroomDescriptionChange: (event: React.FocusEvent<HTMLTextAreaElement>) => void,
    formError: string,
    formSuccessMessage: string,
}

const EditClassroomDescription = ({
    classroomDescription,
    handleInputChange,
    handleClassroomDescriptionChange,
    formError,
    formSuccessMessage,
}: EditClassroomDescriptionProps) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    // Auto-grow the textarea to fit its content: reset to auto so scrollHeight
    // reflects the natural content height (not the previous taller value),
    // then snap height to scrollHeight. min-height in SCSS keeps a sensible floor.
    useLayoutEffect(() => {
        const el = textareaRef.current;
        if (!el) return;
        el.style.height = 'auto';
        el.style.height = `${el.scrollHeight}px`;
    }, [classroomDescription]);

    return (
        <div>
            <h2>Classroom description</h2>
            <p className="classroom-description-subheader subheader">
                A thoughtful description helps donors connect with your kids and gives them confidence that their gift will make a real difference.
            </p>
            <div className="form-redux">
                <div className="classroom-description-holder">
                    <textarea
                        ref={textareaRef}
                        className={(formError ? 'hasError' : '') + 'display-classroom-description'}
                        id="classroomDescription"
                        name="classroomDescription"
                        rows={1}
                        value={classroomDescription}
                        onChange={handleInputChange}
                        onBlur={handleClassroomDescriptionChange}
                    />
                </div>
                {formError ? (<div className="error-text">{formError}</div>) : null}
                {formSuccessMessage ? (<div className="success-text">{formSuccessMessage}</div>) : null}
            </div>
        </div>

    );
};

export default EditClassroomDescription;
